import { lazyPage } from '../../utils/lazyPage';

const MLBBestPicksToday = lazyPage(() => import('./BestPicksToday'));
const MLBmoneyline = lazyPage(() => import('./MLBmoneyline/MLBmoneyline'));
const MLBspread = lazyPage(() => import('./MLBspread/MLBspread'));
const MLBtotal = lazyPage(() => import('./MLBtotal/MLBtotal'));
const MLBPlayerProps = lazyPage(() => import('./MLBPlayerProps/MLBPlayerProps'));

const mlbRoutes = [
  {
    path: '/mlb/best-picks-today',
    label: 'Best Edges Today',
    renderer: (params = {}) => <MLBBestPicksToday {...params} />,
    hidden: true
  },
  {
    path: '/mlb/moneyline',
    label: 'Moneylines',
    renderer: (params = {}) => <MLBmoneyline {...params} />
  },
  {
    path: '/mlb/spread',
    label: 'Spreads',
    renderer: (params = {}) => <MLBspread {...params} />
  },
  {
    path: '/mlb/total',
    label: 'Totals',
    renderer: (params = {}) => <MLBtotal {...params} />
  },
  {
    path: '/mlb/player-props',
    label: 'Player Props',
    renderer: (params = {}) => <MLBPlayerProps {...params} />
  }
];

export default mlbRoutes;
